import { forwardRef, useState } from 'react';

import {
  CORE_GENERAL_FILTER_MAP,
  type CoreGeneralFilterProps,
  type CoreGeneralFilterRef,
  type HandledCoreGeneralFilterDimensionAttributePaths,
} from '../../core-general-filters';
import { SearchInput } from '../../search-input/SearchInput';

export interface CoreGeneralFilterWithSearchInputProps
  extends Omit<CoreGeneralFilterProps, 'searchTerm'> {
  dimensionAttribute: HandledCoreGeneralFilterDimensionAttributePaths;
}

export const CoreGeneralFilterWithSearchInput = forwardRef<
  CoreGeneralFilterRef,
  CoreGeneralFilterWithSearchInputProps
>(({ dimensionAttribute, ...props }, ref) => {
  const [searchTerm, setSearchTerm] = useState('');

  const FilterComponent = CORE_GENERAL_FILTER_MAP[dimensionAttribute];

  return (
    <div className="flex flex-col gap-2 w-fit h-fit">
      <SearchInput
        id={`${dimensionAttribute}-search`}
        value={searchTerm}
        onChange={setSearchTerm}
        debounceDelay={300}
      />
      <FilterComponent
        ref={ref}
        {...props}
        searchTerm={searchTerm}
        className="w-[250px] h-[300px]"
      />
    </div>
  );
});

CoreGeneralFilterWithSearchInput.displayName =
  'CoreGeneralFilterWithSearchInput';
